import { render, staticRenderFns } from "./P019.vue?vue&type=template&id=4fe51c5e"
import script from "./P019.vue?vue&type=script&lang=js"
export * from "./P019.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports